import React from 'react';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { useAsyncState } from '@/utils/hooks';
import { ExportColumnDefinition, getRoomFormOrderExportColumns, RoomFormExportOptions } from '@/services/order-export';
import { ExportColumnSelection } from './ExportColumnSelection';

export interface RoomFormExportConfigurationProps {
    value: RoomFormExportOptions;
    onChange(newValue: RoomFormExportOptions): void;
}

function getDefaultOptions(columns: ExportColumnDefinition[] | null): RoomFormExportOptions {
    return {
        columns: columns ? columns.filter((x) => x.isDefault).map((x) => x.key) : [],
    };
}

export const RoomFormExportConfiguration: React.FC<RoomFormExportConfigurationProps> = ({ value, onChange }) => {
    const [columns] = useAsyncState(() => getRoomFormOrderExportColumns(), [], null);
    const fixedValue: RoomFormExportOptions = {
        ...getDefaultOptions(columns),
        ...value,
    };

    const handleChange = (changes: Partial<RoomFormExportOptions>) => {
        onChange({ ...fixedValue, ...changes });
    };

    const resetToDefaults = () => {
        onChange(getDefaultOptions(columns));
    };

    if (!columns) {
        return null;
    }

    return (
        <div>
            <ExportColumnSelection
                value={fixedValue.columns}
                onChange={(newValue) => handleChange({ columns: newValue })}
                columns={columns}
            />

            <Button variant="primary" onClick={resetToDefaults}>
                <Trans>Reset to default</Trans>
            </Button>
        </div>
    );
};
